import { createAction, props } from '@ngrx/store';
import { EmaidTableRow } from '@pay/pricing-assign-emp-tariff/data/assign-emp-tariff.models';
import { EmpAssignmentUiState } from './emp-assignment.state';

export const setEmaids = createAction(
  '[EmpAssignment] SET_EMAIDS',
  props<{ emaids: EmaidTableRow[] }>()
);
export const setEmaidsLoading = createAction(
  '[EmpAssignment] SET_EMAIDS_LOADING',
  props<{ loading: boolean }>()
);
export const updateEmpAssignmentUI = createAction(
  '[EmpAssignment] UPDATE_UI',
  props<{ ui: Partial<EmpAssignmentUiState> }>()
);
export const resetEmpAssignment = createAction('[EmpAssignment] RESET');
